<template>
  <div>
    <v-content style="min-height: 100vh">
      <v-container fluid fill-height class="pa-0 ma-0">
        <v-layout fill-height>
          <iframe
            data-cy="billing_iframe"
            v-show="token != null"
            :src="iframeSrc"
            frameborder="0"
            height="100%"
            width="100%"
            ref="iframe"
            @load.once="getPartnerIframeToken"
          ></iframe>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>
<script>
import { USER_CRM_RELOAD } from "@/store/actions/user";
import api from "@/utils/api.js";
import i18n from "@/utils/translations";
import { mapGetters } from "vuex";
import restrictions from "../../utils/restrictions";

export default {
  data: () => ({
    partner: null,
    token: null,
    iframeSrc: "https://public.seanapps.app",
  }),
  created() {
    this.partner = this.$route.params.id;
    if (this.partner == null) {
      console.error("BILLING: invalid partner");
      this.$router.push({ name: "billings" });
    }

    const dealership = this.getMe.dealerships.find(
      (dealership) => dealership.uuid === this.partner
    );

    if (dealership != null) {
      const canUsePreprodIframe = restrictions.canUseCrmGroupFeature(
        "can_access_external_billing_preprod",
        dealership.partner_group.uuid
      );

      if (canUsePreprodIframe) {
        this.iframeSrc = "https://public-preprod.seanapps.app";
      }
    }
  },

  mounted() {
    window.addEventListener("message", this.handleOnIframeMessage, false);
  },

  computed: {
    ...mapGetters(["getMe"]),
  },

  beforeDestroy() {
    window.removeEventListener("message", this.handleOnIframeMessage);
  },
  methods: {
    handleOnIframeMessage(event) {
      if (
        (process.env.VUE_APP_NODE_ENV === "TESTING" ||
          event.origin === this.iframeSrc) &&
        event.data === "status-refresh"
      ) {
        this.$store.dispatch(USER_CRM_RELOAD).then(() => {
          this.token = null;
          this.$router.push({ name: "billings" });
        });
      }
    },

    getPartnerIframeToken() {
      api.getBillingIframeToken(this.partner).then((resp) => {
        const { token } = resp.data;

        this.token = token;
        const path = this.parseQueryPath();

        this.$refs.iframe.contentWindow.postMessage(
          {
            token: this.token,
            user_language: i18n.locale,
            extraparams: { ...path },
          },
          this.iframeSrc
        );
      });
    },
    parseQueryPath() {
      const query = this.$route.query;

      if (query == null || Object.keys(query).length === 0) return {};

      let obj = {};
      for (const prop in query) {
        if (prop.match(/^_b_/)) {
          obj = { ...obj, [prop.replace(/^_b_/, "")]: query[prop] };
        }
      }
      return obj;
    },
  },
};
</script>
<style scoped>
.fill-screen {
  height: 100vh;
}
</style>
